import { useQuery } from "@apollo/client";
import { GridInputs } from "../../../../../components/Functional";
import { FETCH_STATUS } from "../../../../../graphql/query/Status";

const Instance = props => {
  const { formik } = props || {};
  const { data: { status = [] } = {} } = useQuery(FETCH_STATUS);

  const inputs = {
    className: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4",
    inputs: [
      {
        className: "gap-4",
        inputs: [
          {
            label: "Status",
            name: "_edition._instance.statusId",
            options: status?.map(item => ({
              label: item.name,
              value: item.id,
            })),
            type: "multi-select",
          },
          {
            label: "Instance Reference",
            name: "_edition._instance.name",
            type: "text",
          },
        ],
      },
    ],
  };

  const gridInputProps = {
    formik,
    ...inputs,
  };

  return <GridInputs {...gridInputProps} />;
};

export default Instance;
